import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AuthenticationService } from 'src/app/others/services/authentication.service';
import { FormStateService } from 'src/app/others/services/form-state.service';
import { getGlobalUserInfo } from 'src/app/others/auth/auth-storage';


@Component({
  selector: 'app-finalize-radiology',
  templateUrl: './finalize-radiology.component.html',
  styleUrls: ['./finalize-radiology.component.scss']
})
export class FinalizeRadiologyComponent {
  pathSignature: FormGroup;
  doctors = [];
  doctor: any;
  doctor2: any;
  doctor3: any;
  authSignature0: any;
  authSignature: any;
  authSignature_: any;
  authSignature2: any;
  authSignature3: any;
  submission_ready: boolean;
  other_doctor = '';
  other_doctor2 = '';
  other_doctor3 = '';
  other_doctor4 = '';
  digital_signature0: any;
  digital_signature: any;
  digital_signature2: any;
  digital_signature3: any;
  digital_signature4: any;
  with_signature: boolean = true;
  finalize_form: boolean;

  userInfo = getGlobalUserInfo();

  userRole = this.userInfo?.role || sessionStorage.getItem("role");
  @Input() peerReview: any;  // Input property to receive peer_review
  @Input() finalPath: boolean = false;
  @Input() isChecked: boolean = false;
  @Output() isCheckedChange = new EventEmitter<boolean>();
  @Output() finalizePayload = new EventEmitter<any>();
  @Output() finalizePay = new EventEmitter<any>();
  @Output() finalizeBoolean = new EventEmitter<any>();
  @Output() finalizeFormChange = new EventEmitter<boolean>();
  curr_user: any;
  selectedDoctor: any;
  selectedDoctor2: any;
  selectedDoctor3: any;
  otherSelectedDoctor: any;
  otherSelectedDoctor2: any;
  otherSelectedDoctor3: any;
  otherSelectedDoctor4: any;
  speciality2: any;
  pathAuthSignature: string;
  specialityy: any;
  loggedInUserId: any;
  peerReviewMatch: boolean = false;
  userId: any;
  userId2: any;
  userId3: any;
  userId4: any;
  pathologists_designation: any;
  pathologists_designation2: any;
  pathologists_designation3: any;
  pathologists_designation4: any;
  pathAuthSignature64: any;
  coSignerName: any;
  coSignerSignature: any;
  doctorDetailsCache: { [id: string]: any } = {};

  constructor(private auth: AuthenticationService, private fb: FormBuilder, private formStateService: FormStateService) {
    this.pathSignature = this.fb.group({
      submission_ready: new FormControl(false),
      pathologists: new FormControl(''),
      pathologists2: new FormControl(''),
      pathologists3: new FormControl(''),
      pathologists4: new FormControl(''),
      other_pathologists: new FormControl(''),
      other_pathologists2: new FormControl(''),
      other_pathologists3: new FormControl(''),
      other_pathologists4: new FormControl(''),
      other_pathologists5: new FormControl(''),
      designation: new FormControl('Releasing Radiologist'),
      designation2: new FormControl(''),
      designation3: new FormControl(''),
      designation4: new FormControl(''),
      finalReview: new FormControl(''),
      finalReview2: new FormControl(''),
      finalReview3: new FormControl(''),
      finalReview4: new FormControl(''),

    });
    this.pathSignature.get('designation').valueChanges.subscribe((value) => {
      let pathologistsValue = this.pathSignature.get('pathologists').value;
      let otherPathologistsValue = this.doctor;
      let otherPathologistsValue2 = this.doctor2;
      let otherPathologistsValue3 = this.doctor3
      if (value === 'Reporting Radiologist') {
        // Disable 'No' radio button and select 'Yes' radio button
        this.pathSignature.get('finalReview').setValue('yes');
        this.createPayLoad()
        this.pathSignature.get('finalReview').disable();
      } else {
        // Enable 'No' radio button
        this.pathSignature.get('finalReview').enable();
      }
    });
    this.pathSignature.get('designation2').valueChanges.subscribe((value) => {
      if (value === 'Reporting Radiologist') {
        // Disable 'No' radio button and select 'Yes' radio button
        this.pathSignature.get('finalReview2').setValue('yes');
        this.pathSignature.get('finalReview2').disable();
      } else {
        // Enable 'No' radio button
        this.pathSignature.get('finalReview2').enable();
      }
    });
    this.pathSignature.get('designation3').valueChanges.subscribe((value) => {
      if (value === 'Reporting Radiologist') {
        // Disable 'No' radio button and select 'Yes' radio button
        this.pathSignature.get('finalReview3').setValue('yes');
        this.pathSignature.get('finalReview3').disable();
      } else {
        // Enable 'No' radio button
        this.pathSignature.get('finalReview3').enable();
      }
    });
    this.pathSignature.get('designation4').valueChanges.subscribe((value) => {
      if (value === 'Reporting Radiologist') {
        // Disable 'No' radio button and select 'Yes' radio button
        this.pathSignature.get('finalReview4').setValue('yes');
        this.pathSignature.get('finalReview4').disable();
      } else {
        // Enable 'No' radio button
        this.pathSignature.get('finalReview4').enable();
      }
    });
  }

  all_radiologists = [];
  all_radiologists_filtered = [];
  all_radiologists2 = [];
  radiologyDoctor = [];

  private extractDoctorsList(response: any): any[] {
    const candidates = [
      response?.doctors,
      response?.doctor,
      response?.data?.doctors,
      response?.data?.doctor,
      response?.data?.data,
      response?.data,
    ];
    for (const candidate of candidates) {
      if (Array.isArray(candidate)) {
        return candidate;
      }
    }
    return [];
  }

  private getDoctorDisplayName(doctor: any): string {
    if (!doctor) {
      return "";
    }
    if (doctor.fullname) {
      return doctor.fullname;
    }
    if (doctor.doctor_full_name) {
      return doctor.doctor_full_name;
    }
    if (doctor.doctor_fullname) {
      return doctor.doctor_fullname;
    }
    if (doctor.name) {
      return doctor.name;
    }
    const othernames = doctor.othernames || doctor.other_names || "";
    const surname = doctor.surname || doctor.last_name || "";
    const speciality = doctor.speciality ? `(${doctor.speciality})` : "";
    const baseName = [othernames, surname].filter(Boolean).join(" ").trim();
    return [baseName, speciality].filter(Boolean).join(" ").trim();
  }

  private getDoctorId(doctor: any): any {
    if (!doctor) {
      return null;
    }
    return doctor.id ?? doctor.doctor_id ?? doctor.user_id ?? doctor.staff_id ?? null;
  }

  private findDoctorByName(name: any): any {
    if (!name || !Array.isArray(this.doctors)) {
      return null;
    }
    if (typeof name === "object") {
      return name;
    }
    const key = String(name);
    const byId = this.doctors.find((doctor) => String(this.getDoctorId(doctor)) === key);
    if (byId) {
      return byId;
    }
    return this.doctors.find((doctor) => {
      return (
        doctor?.display_name === key ||
        doctor?.fullname === key ||
        doctor?.doctor_full_name === key ||
        doctor?.doctor_fullname === key ||
        doctor?.name === key
      );
    });
  }

  private extractDoctorDetails(response: any): any {
    return response?.doctor ?? response?.data?.doctor ?? response?.data ?? response;
  }

  private extractSignatures(details: any): { signature: any; signature64: any } {
    if (!details) {
      return { signature: null, signature64: null };
    }
    const signature =
      details.digital_signature ??
      details.signature ??
      details.auth_signature ??
      details.sign ??
      null;
    const signature64 =
      details.digital_signature_64 ??
      details.signature_64 ??
      details.auth_signature_64 ??
      details.sign_64 ??
      null;
    return { signature, signature64 };
  }

  private fetchDoctorDetails(doctorId: any, onSuccess: (details: any) => void): void {
    if (!doctorId) {
      onSuccess(null);
      return;
    }
    const cacheKey = String(doctorId);
    if (this.doctorDetailsCache[cacheKey]) {
      onSuccess(this.doctorDetailsCache[cacheKey]);
      return;
    }
    const encodedId = encodeURIComponent(String(doctorId));
    this.auth.get(`doctor_details?id=${encodedId}`).subscribe(
      (response) => {
        const details = this.extractDoctorDetails(response);
        this.doctorDetailsCache[cacheKey] = details;
        onSuccess(details);
      },
      () => {
        onSuccess(null);
      }
    );
  }

  private loadDoctorsList(): void {
    this.auth.get('doctors_list').subscribe(
      (response) => {
        const doctors = this.extractDoctorsList(response);
        this.doctors = doctors.map((doctor) => ({
          ...doctor,
          display_name: this.getDoctorDisplayName(doctor),
        }));
        this.all_radiologists = this.doctors.map((doctor) => doctor.display_name);
        this.all_radiologists_filtered = [...this.all_radiologists];
      },
      () => {
        this.doctors = [];
        this.all_radiologists = [];
        this.all_radiologists_filtered = [];
      }
    );
  }

  ngOnInit(): void {
    this.speciality2 = getGlobalUserInfo() || JSON.parse(sessionStorage.getItem("user"));
    const fullname = this.userInfo ? `${this.userInfo.othernames || ''} ${this.userInfo.surname || ''}`.trim() : sessionStorage.getItem("fullname");
    const speciality2 = this.speciality2 && this.speciality2.speciality ? `(${this.speciality2.speciality})` : "";;
    this.loggedInUserId = this.userInfo?.id || sessionStorage.getItem("userID");

    this.loadDoctorsList();
    this.getUserNamee();
    this.pathSignature.valueChanges.subscribe(() => {
      this.checkFormValidity();
    });
  }

  filteredDoctors(selectedDoc) {
    if (!selectedDoc) {
      this.all_radiologists_filtered = [...this.all_radiologists];
      return;
    }
    this.all_radiologists_filtered = this.doctors
      .filter((doctor) => doctor?.display_name !== selectedDoc)
      .map((doctor) => doctor.display_name);
  }


  onPeerReviewCheck() {
    this.speciality2 = getGlobalUserInfo() || JSON.parse(sessionStorage.getItem("user"));
    const fullname = this.userInfo ? `${this.userInfo.othernames || ''} ${this.userInfo.surname || ''}`.trim() : sessionStorage.getItem("fullname");
    const speciality2 = this.speciality2 && this.speciality2.speciality ? `(${this.speciality2.speciality})` : "";
    this.pathAuthSignature64 = this.speciality2?.digital_signature_64;
    this.loggedInUserId = this.userInfo?.id || sessionStorage.getItem("userID");

    if (this.peerReview == this.loggedInUserId) {
      this.pathSignature.get('designation').setValue('Releasing Radiologist');
      this.pathSignature.get("pathologists").setValue(fullname + " " + speciality2);
      this.pathAuthSignature = this.userInfo?.digital_signature || sessionStorage.getItem("digital_signature");
      this.createPayLoad();
      this.peerReviewMatch = true;
    } else {
      this.loadDoctorsList();
      this.peerReviewMatch = false;
    }
    this.getUserNamee();
    this.pathSignature.valueChanges.subscribe(() => {
      this.checkFormValidity();
    });
  }

  getUserName0(e) {
    const email = getGlobalUserInfo() || JSON.parse(sessionStorage.getItem("user"));
    this.curr_user = email?.id;
    const doctor = this.findDoctorByName(e);
    const doctorName =
      doctor?.display_name ??
      this.getDoctorDisplayName(doctor) ??
      (typeof e === "string" ? e : "");
    this.selectedDoctor = doctorName;
    this.pathSignature.get("pathologists").setValue(doctorName);
    const doctorId = this.getDoctorId(doctor);
    const previousSignature = this.pathAuthSignature;
    const previousSignature64 = this.pathAuthSignature64;
    const previousAuthSignature0 = this.authSignature0;
    const previousDigitalSignature0 = this.digital_signature0;
    if (e === null || e === undefined || e === "") {
      this.pathAuthSignature = null;
      this.authSignature0 = null;
      this.digital_signature0 = null;
      this.pathAuthSignature64 = null;
      this.createPayLoad();
      this.createPay();
      this.filteredDoctors(this.selectedDoctor);
      return;
    }
    if (!doctorId) {
      this.pathAuthSignature = previousSignature;
      this.authSignature0 = previousAuthSignature0;
      this.digital_signature0 = previousDigitalSignature0;
      this.pathAuthSignature64 = previousSignature64;
      this.createPayLoad();
      this.createPay();
      this.filteredDoctors(this.selectedDoctor);
      return;
    }
    this.fetchDoctorDetails(doctorId, (details) => {
      const { signature, signature64 } = this.extractSignatures(details);
      this.pathAuthSignature = signature ?? previousSignature;
      this.authSignature0 = signature ?? previousAuthSignature0;
      this.digital_signature0 = signature64 ?? previousDigitalSignature0;
      this.pathAuthSignature64 = signature64 ?? previousSignature64;
      this.createPayLoad();
      this.createPay();
    });
    this.filteredDoctors(this.selectedDoctor);
  }

  checkSubmission(value) {
    this.finalizeBoolean.emit(value.target.checked)
    this.isCheckedChange.emit(value.target.checked);
    this.submission_ready = value.target.checked;

    if (value.target.checked) {
      this.finalize_form = true
    } else {
      this.finalize_form = false
      this.resetForm();
    }
    this.getUserName(null);
    this.pathAuthSignature64 = this.speciality2?.digital_signature_64;
  }

  checkFormValidity() {
    const finalReview = this.pathSignature.get('finalReview').value;
    const otherPathologists = this.pathSignature.get('other_pathologists').value;
    if ((finalReview === 'yes' && otherPathologists) || finalReview === 'no') {
      this.formStateService.updateFormState(true);
    } else {
      this.formStateService.updateFormState(false);
    }
  }

  getUserNamee() {
    const email = getGlobalUserInfo() || JSON.parse(sessionStorage.getItem("user"));
    const doc = this.doctors.filter((a) => a.email == email.email);
    this.curr_user = email?.id;
  }


  private resetForm() {
    // Reset the form control and clear the selected doctor
    this.selectedDoctor = null;
    this.selectedDoctor2 = null;
    this.selectedDoctor3 = null;
    this.otherSelectedDoctor = null;
    this.otherSelectedDoctor2 = null;
    this.otherSelectedDoctor3 = null;
    this.otherSelectedDoctor4 = null;
    this.authSignature2 = null;
    this.authSignature3 = null;
    this.digital_signature2 = null;
    this.digital_signature3 = null;
    this.digital_signature4 = null;
    this.doctor = null;
    this.doctor2 = null;
    this.doctor3 = null;
    this.other_doctor = null;
    this.other_doctor2 = null;
    this.other_doctor3 = null;
    this.other_doctor4 = null;
    this.coSignerName = null;
    this.coSignerSignature = null;
    this.userId = null;
    this.pathAuthSignature = null;
    this.pathSignature.patchValue({
      designation: '',
      designation2: '',
      designation3: '',
      designation4: '',
      finalReview: '',
      finalReview2: '',
      finalReview3: '',
      finalReview4: ''
    });
  }

  noReset() {
    // this.selectedDoctor = null;
    this.selectedDoctor2 = null;
    this.selectedDoctor3 = null;
    this.otherSelectedDoctor = null;
    this.otherSelectedDoctor2 = null;
    this.otherSelectedDoctor3 = null;
    this.otherSelectedDoctor4 = null;
    this.authSignature2 = null;
    this.authSignature3 = null;
    this.digital_signature2 = null;
    this.digital_signature3 = null;
    this.digital_signature4 = null;
    this.doctor = null;
    this.doctor2 = null;
    this.doctor3 = null;
    this.other_doctor = null;
    this.other_doctor2 = null;
    this.other_doctor3 = null;
    this.other_doctor4 = null;
    this.coSignerName = null;
    this.coSignerSignature = null;
    this.createPayLoad()
  }
  onPeerReview() {
    this.peerReview
  }
  public triggerCheckSubmission(value: boolean) {
    this.isChecked = value;
    this.checkSubmission({ target: { checked: value } });
  }
  createPayLoad() {
    let pathologistsValue = this.pathSignature.get('pathologists').value;
    let otherPathologistsValue = this.doctor;
    let otherPathologistsValue2 = this.doctor2;
    let otherPathologistsValue3 = this.doctor3;

    let designationValue = this.pathSignature.get('designation').value;
    let designationValue2 = this.pathSignature.get('designation2').value;

    if (this.pathSignature.get('finalReview').value === 'yes') {
      // If Yes is selected, swap values
      let temp = pathologistsValue;
      pathologistsValue = otherPathologistsValue;
      otherPathologistsValue = temp;

      let tempD = designationValue;
      designationValue = designationValue2;
      designationValue2 = tempD;
    } else if (this.pathSignature.get('finalReview').value === 'no') {
      let temp = pathologistsValue;
      pathologistsValue = temp;
      otherPathologistsValue = this.coSignerName;
    }

    if (this.pathSignature.get('finalReview2').value === 'yes') {
      // If Yes is selected, swap values
      let temp = pathologistsValue;
      pathologistsValue = otherPathologistsValue;
      otherPathologistsValue = temp;

    }

    let pathSignatureValue = this.pathAuthSignature;
    let otherPathologistsAuthSignatureValue = this.userId2;
    let otherPathologists2AuthSignatureValue = this.userId3;
    let otherPathologistsA3uthSignatureValue = this.userId4;

    if (this.pathSignature.get('finalReview').value === 'yes') {
      let authTemp = pathSignatureValue;
      pathSignatureValue = otherPathologistsAuthSignatureValue;
      otherPathologistsAuthSignatureValue = authTemp;

    } else if (this.pathSignature.get('finalReview').value === 'no') {
      let authTemp = pathSignatureValue;
      pathSignatureValue = authTemp;
      otherPathologistsAuthSignatureValue = this.coSignerSignature;
    }

    if (this.pathSignature.get('finalReview2').value === 'yes') {
      // If Yes is selected, swap values
      let authTemp = pathSignatureValue;
      pathSignatureValue = otherPathologistsAuthSignatureValue;
      otherPathologistsAuthSignatureValue = authTemp;
    }

    const payload = {
      submission_ready: this.submission_ready,
      pathologists: pathologistsValue,
      other_pathologists: otherPathologistsValue,
      pathologists_designation: designationValue,
      other_pathologists_designation: designationValue2,
      auth_signature: pathSignatureValue,
      other_pathologists_auth_signature: otherPathologistsAuthSignatureValue,
      peer_review: this.pathSignature.get('finalReview').value === 'yes' ? this.userId : null,
      with_signature: this.with_signature,
      user_id: this.curr_user,
    };
    this.finalizePayload.emit(payload);
    return null
  }

  createPay() {
    const payload = {
      submission_ready: this.submission_ready,
      pathologists: this.pathSignature.get('pathologists').value,
      pathologists_designation: this.pathSignature.get('designation').value,
      auth_signature: this.pathAuthSignature,
      auth_signature_64: this.pathAuthSignature64,
      peer_review: this.userId,
    };
    this.finalizePay.emit(payload);
  }

  getUserName(e) {
    const email = getGlobalUserInfo() || JSON.parse(sessionStorage.getItem("user"));
    const doctor = this.findDoctorByName(e);
    this.doctor =
      doctor?.display_name ??
      this.getDoctorDisplayName(doctor) ??
      (typeof e === "string" ? e : "");
    const doctorId = this.getDoctorId(doctor);
    const previousUserId2 = this.userId2;
    const previousSignature = this.authSignature;
    const previousSignature64 = this.digital_signature2;
    if (e === null || e === undefined || e === "") {
      this.userId2 = null;
      this.authSignature = null;
      this.digital_signature2 = null;
      this.createPayLoad();
      this.createPay();
      return;
    }
    if (!doctorId) {
      this.userId2 = previousUserId2;
      this.authSignature = previousSignature;
      this.digital_signature2 = previousSignature64;
      this.createPayLoad();
      this.createPay();
      return;
    }
    this.fetchDoctorDetails(doctorId, (details) => {
      const { signature, signature64 } = this.extractSignatures(details);
      this.userId2 = signature ?? previousUserId2;
      this.authSignature = signature ?? previousSignature;
      this.digital_signature2 = signature64 ?? previousSignature64;
      this.createPayLoad();
      this.createPay();
    });

  }
  getUserName2(e) {
    const email = getGlobalUserInfo() || JSON.parse(sessionStorage.getItem("user"));
    const doctor = this.findDoctorByName(e);
    this.doctor2 =
      doctor?.display_name ??
      this.getDoctorDisplayName(doctor) ??
      (typeof e === "string" ? e : "");
    const doctorId = this.getDoctorId(doctor);
    const previousUserId3 = this.userId3;
    const previousSignature = this.authSignature2;
    const previousSignature64 = this.digital_signature3;
    if (e === null || e === undefined || e === "") {
      this.userId3 = null;
      this.authSignature2 = null;
      this.digital_signature3 = null;
      this.createPayLoad();
      this.createPay();
      return;
    }
    if (!doctorId) {
      this.userId3 = previousUserId3;
      this.authSignature2 = previousSignature;
      this.digital_signature3 = previousSignature64;
      this.createPayLoad();
      this.createPay();
      return;
    }
    this.fetchDoctorDetails(doctorId, (details) => {
      const { signature, signature64 } = this.extractSignatures(details);
      this.userId3 = signature ?? previousUserId3;
      this.authSignature2 = signature ?? previousSignature;
      this.digital_signature3 = signature64 ?? previousSignature64;
      this.createPayLoad();
      this.createPay();
    });

  }
  getUserName3(e) {
    const email = getGlobalUserInfo() || JSON.parse(sessionStorage.getItem("user"));
    const doctor = this.findDoctorByName(e);
    this.doctor3 =
      doctor?.display_name ??
      this.getDoctorDisplayName(doctor) ??
      (typeof e === "string" ? e : "");
    const doctorId = this.getDoctorId(doctor);
    const previousUserId4 = this.userId4;
    const previousSignature = this.authSignature3;
    const previousSignature64 = this.digital_signature4;
    if (e === null || e === undefined || e === "") {
      this.userId4 = null;
      this.authSignature3 = null;
      this.digital_signature4 = null;
      this.createPayLoad();
      this.createPay();
      return;
    }
    if (!doctorId) {
      this.userId4 = previousUserId4;
      this.authSignature3 = previousSignature;
      this.digital_signature4 = previousSignature64;
      this.createPayLoad();
      this.createPay();
      return;
    }
    this.fetchDoctorDetails(doctorId, (details) => {
      const { signature, signature64 } = this.extractSignatures(details);
      this.userId4 = signature ?? previousUserId4;
      this.authSignature3 = signature ?? previousSignature;
      this.digital_signature4 = signature64 ?? previousSignature64;
      this.createPayLoad();
      this.createPay();
    });
  }

  designation() {
    this.pathologists_designation = this.pathSignature.get('designation').value;
    this.createPayLoad();
    this.createPay();

  }
  designation2() {
    this.pathologists_designation2 = this.pathSignature.get('designation').value;
    this.createPayLoad();
    this.createPay();

  }

  otherDoctor(e) {
    const doctor = this.findDoctorByName(e);
    this.other_doctor =
      doctor?.display_name ??
      this.getDoctorDisplayName(doctor) ??
      (typeof e === "string" ? e : "");
    const doctorId = this.getDoctorId(doctor);
    const previousUserId = this.userId;
    const previousCoSignerSignature = this.coSignerSignature;
    const previousUserId2 = this.userId2;
    this.coSignerName = this.other_doctor;
    if (e === null || e === undefined || e === "") {
      this.userId = null;
      this.coSignerSignature = null;
      this.userId2 = null;
      this.createPayLoad();
      this.createPay();
      return;
    }
    if (!doctorId) {
      this.userId = previousUserId;
      this.coSignerSignature = previousCoSignerSignature;
      this.userId2 = previousUserId2;
      this.createPayLoad();
      this.createPay();
      return;
    }
    this.userId = doctorId;
    this.fetchDoctorDetails(doctorId, (details) => {
      const { signature } = this.extractSignatures(details);
      this.coSignerSignature = signature ?? previousCoSignerSignature;
      this.userId2 = signature ?? previousUserId2;
      this.createPayLoad();
      this.createPay();
    });
  }
  otherDoctor2(e) {
    const doctor = this.findDoctorByName(e);
    this.other_doctor2 =
      doctor?.display_name ??
      this.getDoctorDisplayName(doctor) ??
      (typeof e === "string" ? e : "");
    const doctorId = this.getDoctorId(doctor);
    this.userId = doctorId;
    this.createPayLoad();
    this.createPay()
  }

  addNewItem() {
    const name = 'Hello'
    this.finalizePayload.emit(name);
  }

}
